module.exports = __webpack_public_path__ + "static/media/app-logo.b16ac3d9.svg";